import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import "../UserDashboardHome/UserDashboardHome.css";
import localeText from "../../../../locale";
import GetUserInfoService from "../../../../service/GetUserInfoService";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import "../StatementTable/StatementTable.css";
import { Column } from "primereact/column";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

const Coupons = (props) => {
  const getUserInfoService = new GetUserInfoService();

  const [amount, setAmount] = useState(50);
  const [generatedCoupon, setGeneratedCoupon] = useState("");
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useRef(null);

  const accept = () => {
    generateCoupon(
      localStorage.getItem("__extraconomy_token"),
      amount,
      localStorage.getItem("__extraconomy_username")
    );
  };

  const reject = () => {};

  const confirm1 = () => {
    confirmDialog({
      message: localeText("areYouSureCoupon"),
      header: localeText("confirmYourAction"),
      icon: "pi pi-exclamation-triangle",
      breakpoints: { "960px": "75vw", "640px": "100vw" },
      acceptLabel: localeText("confirm"),
      rejectLabel: localeText("cancel"),
      accept,
      reject,
    });
  };

  async function generateCoupon(token, amount, username) {
    try {
      setLoading(true);

      const resCoupon = await getUserInfoService.postCouponInvite(token, amount, username);

      if (resCoupon.messageCode === 200000) {
        toast.current.show({
          severity: "success",
          summary: localeText("success"),
          detail: localeText("couponGenerated"),
          life: 6000,
        });
        setGeneratedCoupon(resCoupon.result.number);
        const generatedCouponElem = document.getElementById("generated-coupon");
        generatedCouponElem.select();
        generatedCouponElem.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(generatedCouponElem.value);
        getCouponsInfo(false);
      } else {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === resCoupon.messageCode).message,
          life: 6000,
        });
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  }

  useEffect(() => {
    let cancel = false;
    getCouponsInfo(cancel);
    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getCouponsInfo(cancel) {
    try {
      getUserInfoService
        .getCoupons(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username")
        )
        .then((res) => {
          if (cancel) return;

          try {
            if (res.messageCode !== 200001) {
              toast.current.show({
                severity: "error",
                summary: localeText("error"),
                detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
                life: 6000,
              });
              setLoading(false);
            } else {
              setLoading(false);
              setCoupons(res.result);
            }
          } catch (e) {
            setLoading(false);
            console.log(e);
          }
        });
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  }

  return (
    <div>
      <Toast ref={toast} />
      <div className="card border-1 border-300">
        {props.plan !== "Customer" ? (
          <>
            <ConfirmDialog />
            <h3 className="my-4">{localeText("specialCustomerRegisterCoupons")}</h3>
            <hr />

            <div className="md:flex lg:flex md:align-items-center lg:align-items-center lg:text-left md:text-left block text-center">
              <ul className="list-none p-0 mr-2">
                <li>
                  <label htmlFor="amount">{localeText("extracoinAmount")}</label>
                </li>
                <li className="mt-2">
                  <InputNumber
                    name="amount"
                    value={amount}
                    onValueChange={(e) => setAmount(e.value)}
                    min={50}
                    showButtons
                  />
                </li>
              </ul>
              <Button
                label={localeText("generateCoupon")}
                onClick={() => confirm1()}
                loading={loading}
                icon="pi pi-plus"
                className="mr-2 button-check-statement p-button-success"
              />
              <ul className="list-none p-0 mr-2">
                <li className="mb-0">
                  <label htmlFor="generated-coupon">{localeText("generatedCoupon")}</label>
                </li>
                <li>
                  <InputText
                    id="generated-coupon"
                    value={generatedCoupon}
                    style={{ marginTop: "7px" }}
                  />
                </li>
              </ul>
              <Button
                label={localeText("copy")}
                icon="pi pi-link"
                iconPos="right"
                className="p-2 p-button-rounded p-button-outlined button-check-statement"
                onClick={() => {
                  navigator.clipboard.writeText(generatedCoupon);
                  toast.current.show({
                    severity: "info",
                    summary: localeText("copied"),
                    detail: localeText("copiedToClipboard"),
                    life: 6000,
                  });
                }}
              />
            </div>

            <DataTable
              className="mt-3"
              value={coupons}
              paginator
              responsiveLayout="scroll"
              loading={loading}
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate={localeText("showingFirstToLast")}
              rows={10}
              rowsPerPageOptions={[10, 20, 50]}
            >
              <Column field="number" header={localeText("coupon")} style={{ width: "20%" }} />
              <Column
                field="amount"
                header={localeText("extracoinAmount")}
                style={{ width: "20%" }}
              />
              <Column field="currency" header={localeText("currency")} style={{ width: "20%" }} />
              <Column
                field="userRegistered.username"
                header={localeText("usedBy")}
                style={{ width: "20%" }}
              />
              <Column
                style={{ width: "20%" }}
                header={localeText("used")}
                body={(rowData) => {
                  return (
                    <>
                      {rowData.used && (
                        <span
                          className="team-member-role text-0 p-1 border-round"
                          style={{ backgroundColor: "#eb4034" }}
                        >
                          {localeText("used")}
                        </span>
                      )}
                      {!rowData.used && (
                        <span
                          className="team-member-role text-0 p-1 border-round"
                          style={{ backgroundColor: "#46a748" }}
                        >
                          {localeText("notUsed")}
                        </span>
                      )}
                    </>
                  );
                }}
              />
            </DataTable>
          </>
        ) : (
          <div className="text-center">
            <i className="pi pi-lock text-8xl text-400 my-4"></i>
            <h2 className="my-6">{localeText("planNotAllowed")}</h2>
          </div>
        )}
      </div>
    </div>
  );
};

export default Coupons;
